// extracted by mini-css-extract-plugin
export default {"customBox":"profile_customBox__-nP4r"};